/* unplugin-vue-components disabled */import script from "./ToolDescription.vue?vue&type=script&setup=true&lang=js"
export * from "./ToolDescription.vue?vue&type=script&setup=true&lang=js"

import "./ToolDescription.vue?vue&type=style&index=0&id=168bf10a&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-168bf10a"]])

export default __exports__